import { render, staticRenderFns } from "./documentsList.vue?vue&type=template&id=6636410a&"
import script from "./documentsList.vue?vue&type=script&lang=js&"
export * from "./documentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports